<template>
  <RygenChip v-if="status" :severity="severity" :label="label" />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { OrderStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<OrderStatus>,
    default: () => '',
  },
});
const { status } = toRefs(props);

const label = computed((): string => {
  return translateEnum(status.value, 'OrderStatus');
});

const severity = computed(() => {
  switch (status?.value) {
    case OrderStatus.COMPLETE:
      return Severity.SUCCESS;
    case OrderStatus.SHIPPED:
    case OrderStatus.DELIVERED:
    case OrderStatus.BILLED:
      return Severity.SUCCESS_LIGHT;
    case OrderStatus.IN_PROCESS:
      return Severity.INFO;
    case OrderStatus.CUSTOMER_REVIEW:
      return Severity.WARNING;
    case OrderStatus.PENDING:
    case OrderStatus.CANCELED:
    default:
      return undefined;
  }
});
</script>
